import React from 'react';
import { Calendar, Star } from 'lucide-react';

interface HotelCardProps {
  name: string;
  description: string;
  image: string;
  rating: number;
  amenities: string[];
  price: string;
  onBookNow: () => void;
}

export default function HotelCard({ 
  name, 
  description, 
  image, 
  rating, 
  amenities, 
  price, 
  onBookNow 
}: HotelCardProps) {
  return (
    <div className="group bg-white rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl">
      <div className="relative">
        <img 
          src={image} 
          alt={name} 
          className="w-full h-64 object-cover"
        />
        <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full flex items-center">
          <Star className="w-4 h-4 mr-1 fill-current" />
          {rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
          <p className="text-white text-2xl font-bold">{price}<span className="text-sm">/night</span></p>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">{name}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">Amenities:</h4>
          <div className="flex flex-wrap gap-2">
            {amenities.map((amenity, index) => (
              <span 
                key={index}
                className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full"
              >
                {amenity}
              </span>
            ))}
          </div>
        </div>
        <button
          onClick={onBookNow}
          className="flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-blue-800 text-white py-3 px-6 rounded-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 transform hover:-translate-y-1"
        >
          <Calendar className="mr-2" size={20} />
          Book Now
        </button>
      </div>
    </div>
  );
}